<template>
<div class="canvas-wrapper">
    <P5Wrapper v-model="p5Instance" :sketch="(p, width, height) => habitSketch(p, kaleadical, width, height)" @click="onClick" />
</div>
</template>

<script>
import P5Wrapper from '../components/P5Wrapper.vue';
import habitSketch from '../sketches/habitSketch';
import { onMounted, ref, watch } from 'vue';
import { useKaleadicalStore } from '@/stores/kaleadical';

export default {
    components: { P5Wrapper },

    props: {
        kaleadical: {
            type: Object,
            required: true
        },

        scale: {
            type: Number,
            default: 1
        }
    },

    setup(props) {
        const p5Instance = ref(null);

        const { uploadImage } = useKaleadicalStore();

        watch(() => props.scale, (val) => {
            updateScale(val);
        });

        const updateScale = (val) => {
            p5Instance.value.updateScale(val);
        };

        onMounted(async () => {
            updateScale(props.scale);
            p5Instance.value.setFirstFrameCallback(() => {
                const canvas = p5Instance.value.canvas;
                const dataURL = canvas.toDataURL('image/png');
                const base64Data = dataURL;

                const payload = {
                    image: base64Data
                };

                uploadImage(props.kaleadical, payload);
            });
        });

        const onClick = () => {
            p5Instance.value.setNewRotate(10);
        };

        return { habitSketch, p5Instance, onClick };
    },
};
</script>

<style scoped>
.canvas-wrapper {
  width: 100%; /* Adjust as needed */
  height: 100%; /* Adjust as needed */
  border: 2px solid #ccc; /* Optional: Visual border for debugging */
  position: relative;
}
</style>
